const initialState = {
    refDataEnrichments: [],
    refDataEnrichConfigs: []
};
export default initialState;